import LogoFullImageNegative from "./logo/KV-Logo-Color-Negative.png";



const LogoFull = () => (
  <img height={30}
    width="auto"
    src={LogoFullImageNegative}
    alt="Kinetic Vision Logo" />
);

export default LogoFull;
